import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../Hooks/useFormName';
import ErrorMessage from '../ErrorMessage';
import Select, { SelectProps } from '../Select';
import TopFieldContent from '../TopFieldContent';
import InputWrapper from '../InputWrapper/InputWrapper';
import { MenuPlacement } from '../../../../Modules/Base/Enums/MenuPlacement.enum';

interface SelectFieldProps extends SelectProps {
	name: string;
	label?: string;
	className?: string;
	isRequired?: boolean;
	onFieldChange?: (...event: any) => void;
	portal?: boolean;
	isFixed?: boolean;
	isSearchable?: boolean;
	isWrapped?: boolean;
	menuPlacement?: MenuPlacement;
}

const SelectField = ({
	name,
	label,
	className,
	isRequired,
	onFieldChange,
	portal,
	isFixed,
	isSearchable,
	isWrapped,
	...selectProps
}: SelectFieldProps) => {
	const { fieldName } = useFormName({ name });

	const { control } = useFormContext();

	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName,
		defaultValue: {},
	});

	// @ts-ignore
	const errorMessage = (error?.message || error?.value?.message) ?? undefined;

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			<Select
				hasError={Boolean(error)}
				{...selectProps}
				{...field}
				{...(onFieldChange && {
					onChange: event => {
						onFieldChange?.(event);
						field.onChange(event);
					},
				})}
				portal={portal}
				isFixed={isFixed}
				isSearchable={isSearchable}
				isClearable={selectProps.isClearable ?? !isRequired}
			/>
			{errorMessage && <ErrorMessage tx={errorMessage} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default SelectField;
